import AuthGuard from "@/middleware/auth";

export default [
  { path: "/admin/users", name: "ManageUsers", component: () => import("@/views/admin/users"), beforeEach: AuthGuard },
  { path: "/admin/menus", name: "ManageMenus", component: () => import("@/views/admin/menus"), beforeEach: AuthGuard },
  { path: "/admin/menus/assign", name: "AssignMenus", component: () => import("@/views/admin/assign_menu"), beforeEach: AuthGuard },
  { path: "/admin/airlines", name: "Airlines", component: () => import("@/views/admin/airlines"), beforeEach: AuthGuard },
  { path: "/admin/suppliers", name: "Suppliers", component: () => import("@/views/admin/suppliers"), beforeEach: AuthGuard },
  { path: "/admin/cruises", name: "Cruises", component: () => import("@/views/admin/cruises"), beforeEach: AuthGuard },
  { path: "/admin/airports", name: "Airports", component: () => import("@/views/admin/airports"), beforeEach: AuthGuard },
  { path: "/admin/countries", name: "Countries", component: () => import("@/views/admin/countries"), beforeEach: AuthGuard },
  { path: "/admin/settings", name: "Settings", component: () => import("@/views/admin/settings"), beforeEach: AuthGuard }
];
